<!--
 * @Description: 商品批次流通追溯详情
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:58:03
 * @LastEditTime: 2021-01-05 09:31:06
-->
<template>
  <div
    class="goods-trace-detail"
    v-loading="loading"
    element-loading-text="拼命加载中"
  >
    <e6-title>商品批次流通追溯详情</e6-title>
    <section class="goods-trace-detail-container">
      <div class="goods-trace-detail-content">
        <div class="main">
          <!-- 商品信息 -->
          <div class="item goods-info">
            <div class="item-title">
              <h2 class="item-title--content">商品信息</h2>
              <span class="item-title--btn"></span>
            </div>
            <div class="item-content">
              <el-form label-width="200px">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="追溯码">
                      {{ goodsDetail.tagCode }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="商品名称">
                      {{ goodsDetail.productName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="生产厂商">
                      {{ goodsDetail.manufacturer }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="所属商户">
                      {{ goodsDetail.companyName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="商户联系方式">
                      {{ goodsDetail.companyTel }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="厂商地址">
                      {{ goodsDetail.productionAddress }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="原产地">
                      {{ goodsDetail.countryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="入境口岸">
                      {{ goodsDetail.portName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="入境日期">
                      {{ goodsDetail.entryDate }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>

          <!-- 追溯节点详情 -->
          <div class="item trace-node-detail">
            <div class="item-title">
              <h2 class="item-title--content">追溯节点详情</h2>
              <ul class="stage-radio">
                <li
                  v-for="stage in stageList"
                  :class="[
                    'stage-radio--item',
                    stageRadio == stage ? 'active' : ''
                  ]"
                  :key="`stage${stage}`"
                  @click="handleTraceNodeStageRadioClick(stage)"
                >
                  第{{ stage | stageFilter }}阶段
                </li>
              </ul>
            </div>
            <div class="item-content">
              <div
                class="item-content-stage"
                v-for="(item, index) in traceNodeDetail"
                :key="`trace-node-${index}`"
                v-show="stageRadio == index + 1"
              >
                <!-- 步骤条 -->
                <div class="item-content-stage--step">
                  <el-steps
                    :active="step"
                    finish-status="success"
                    process-status="wait"
                    align-center
                  >
                    <el-step title="入库">
                      <div
                        slot="description"
                        v-if="JSON.stringify(item.warehouse) !== '{}'"
                        v-html="getStageStepTime(item.warehouse.warehouseTime)"
                      ></div>
                      <div slot="icon"></div>
                    </el-step>
                    <el-step title="出库">
                      <div
                        slot="description"
                        v-if="JSON.stringify() !== '{}'"
                        v-html="
                          getStageStepTime(item.exWarehouse.exWarehouseTime)
                        "
                      ></div>
                      <div slot="icon"></div>
                    </el-step>
                    <el-step title="装车">
                      <div
                        slot="description"
                        v-if="JSON.stringify(item.loadGoods) !== '{}'"
                        v-html="
                          getStageStepTime(item.loadGoods.waybillStartTime)
                        "
                      ></div>
                      <div slot="icon"></div>
                    </el-step>
                    <el-step title="开始运输">
                      <div
                        slot="description"
                        v-if="JSON.stringify(item.startTransport) !== '{}'"
                        v-html="
                          getStageStepTime(
                            item.startTransport.transportStartTime
                          )
                        "
                      ></div>
                      <div slot="icon"></div>
                    </el-step>
                    <el-step title="结束运输">
                      <div
                        slot="description"
                        v-if="JSON.stringify(item.endTransport) !== '{}'"
                        v-html="
                          getStageStepTime(item.endTransport.transportEndTime)
                        "
                      ></div>
                      <div slot="icon"></div>
                    </el-step>
                  </el-steps>
                </div>
                <div class="item-content-stage--content">
                  <!-- 入库 -->
                  <div
                    class="stage-info"
                    v-if="JSON.stringify(item.warehouse) !== '{}'"
                  >
                    <div class="stage-info-title">入库</div>
                    <div class="stage-info-content">
                      <el-row>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">入库公司</div>
                            <div class="stage-info-item--content">
                              {{ item.warehouse.companyName }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">入库仓库</div>
                            <div class="stage-info-item--content">
                              {{ item.warehouse.storageName }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">入库库区</div>
                            <div class="stage-info-item--content">
                              {{ item.warehouse.storageAreaName }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">入库时间</div>
                            <div class="stage-info-item--content">
                              {{ item.warehouse.warehouseTime }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- 出库 -->
                  <div
                    class="stage-info"
                    v-if="JSON.stringify(item.exWarehouse) !== '{}'"
                  >
                    <div class="stage-info-title">出库</div>
                    <div class="stage-info-content">
                      <el-row>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">在库最高温</div>
                            <div class="stage-info-item--content">
                              {{ item.exWarehouse.temperatureMax }}℃
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">在库最低温</div>
                            <div class="stage-info-item--content">
                              {{ item.exWarehouse.temperatureMin }}℃
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">
                              在库平均温度
                            </div>
                            <div class="stage-info-item--content">
                              {{ item.exWarehouse.temperatureAvg }}℃
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">出库时间</div>
                            <div class="stage-info-item--content">
                              {{ item.exWarehouse.exWarehouseTime }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- 装车 -->
                  <div
                    class="stage-info"
                    v-if="JSON.stringify(item.loadGoods) !== '{}'"
                  >
                    <div class="stage-info-title">装车</div>
                    <div class="stage-info-content">
                      <el-row>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">承运公司</div>
                            <div class="stage-info-item--content">
                              {{ item.loadGoods.companyName }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">运输车辆</div>
                            <div class="stage-info-item--content">
                              {{ item.loadGoods.vehicleName }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">运输司机</div>
                            <div class="stage-info-item--content">
                              {{ item.loadGoods.driverName }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">
                              司机联系方式
                            </div>
                            <div class="stage-info-item--content">
                              {{ item.loadGoods.driverTel }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- 开始运输 -->
                  <div
                    class="stage-info"
                    v-if="JSON.stringify(item.startTransport) !== '{}'"
                  >
                    <div class="stage-info-title">开始运输</div>
                    <div class="stage-info-content">
                      <el-row>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">出发位置</div>
                            <div class="stage-info-item--content">
                              {{ item.startTransport.transportStartAddress }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">
                              运输开始时间
                            </div>
                            <div class="stage-info-item--content">
                              {{ item.startTransport.transportStartTime }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div
                    class="stage-info"
                    v-if="JSON.stringify(item.endTransport) !== '{}'"
                  >
                    <div class="stage-info-title">结束运输</div>
                    <div class="stage-info-content">
                      <el-row>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">收货人</div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.receiverName }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">收货人电话</div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.receiverTel }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">
                              收货详细地址
                            </div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.receiverAddress }}
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">在途最高温</div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.temperatureMax }}℃
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">在途最低温</div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.temperatureMin }}℃
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">在途平均温</div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.temperatureAvg }}℃
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="stage-info-item">
                            <div class="stage-info-item--label">到达时间</div>
                            <div class="stage-info-item--content">
                              {{ item.endTransport.transportEndTime }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 追溯全程温度信息 -->
          <div class="item trace-whole-temperature">
            <div class="item-title">
              <h2 class="item-title--content">追溯全程温度信息</h2>
            </div>
            <div class="item-content">
              <div class="item-content-wrap" v-show="temperData.length !== 0">
                <div class="item-content-chart" ref="temperatureChart"></div>
                <div
                  class="all-scene"
                  :style="{ width: `${temperChartWidth}px` }"
                >
                  <ul class="scenes">
                    <template v-for="(item, index) in scenes">
                      <li
                        v-if="item.sceneType"
                        :key="index"
                        class="scene-item"
                        :style="getSceneStyle(item)"
                      >
                        <div class="title" :title="item.sceneName">
                          {{ item.sceneName }}
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
              <div class="nodata-wrap" v-show="temperData.length === 0">
                <div class="nodate">
                  <img src="../../assets/images/pg-nodata.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          <!-- 追溯全程轨迹信息 -->
          <div class="item trace-whole-track">
            <div class="item-title">
              <h2 class="item-title--content">追溯全程轨迹信息</h2>
            </div>
            <div class="item-content">
              <track-map ref="trackMap"></track-map>
            </div>
          </div>
        </div>
      </div>
      <div class="goods-trace-detail-footer">
        <el-button class="goback-btn" @click="handleGoBack">返回</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  fetchGoodsByTagCode,
  fetchTraceDetail,
  fetchWholeTraceTrack,
  fetchWholeTraceTemperature
} from "@/api/goodsTrace/goodsTrace.js";
import { cloneDeep } from "lodash";
import moment from "moment";
import echarts from "echarts";
import trackMap from "./components/trackMap";

export default {
  components: {
    trackMap
  },
  data() {
    return {
      loading: false,
      goodsDetail: {
        tagCode: "", // 追溯码
        productName: "", // 商品名称
        manufacturer: "", // 生产厂商
        companyName: "", // 所属商户
        companyTel: "", // 商户联系方式
        productionAddress: "", // 厂商地址
        isImport: "", // 是否进口 1-是 0-否
        countryName: "", // 原产国/地
        portName: "", // 口岸名称（入境口岸）
        entryDate: "" // 入境日期
      },
      traceNodeDetail: [], // 追溯节点详情
      temperData: [], // 温度数据
      stageList: [],
      stageRadio: 1,
      step: 1, // 当前步骤
      scenes: [],
      sceneBTime: 0,
      sceneETime: 0,
      temperChartWidth: 0,
      tempMinOrMax: [],
      temperChart: null,
      tagCode: "", // 商品码
      stage: 1, // 阶段
      warehouseId: "",
      trackColorList: ["#4da820", "#bcbec2"] // 轨迹颜色
    };
  },
  created() {
    let { tagCode, stage, warehouseId } = this.$route.query;
    this.tagCode = tagCode;
    this.stageRadio = stage;
    this.stage = stage;
    this.warehouseId = warehouseId;
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.reszieChart());
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reszieChart());
  },
  filters: {
    stageFilter(val) {
      let numMap = new Map([
        [1, "一"],
        [2, "二"],
        [3, "三"],
        [4, "四"],
        [5, "五"],
        [6, "六"],
        [7, "七"],
        [8, "八"],
        [9, "九"]
      ]);
      return numMap.get(val);
    }
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        let goodsRes = await fetchGoodsByTagCode({
          tagCode: this.tagCode
        });

        if (goodsRes.code === 1 && goodsRes.result) {
          this.goodsDetail = cloneDeep(goodsRes.result);

          let promiseList = [
            fetchTraceDetail({
              codeId: this.goodsDetail.codeId,
              warehouseId: this.warehouseId
            }),
            fetchWholeTraceTemperature({
              codeId: this.goodsDetail.codeId
            })
          ];

          let [detailRes, temperRes] = await Promise.all(promiseList);

          if (detailRes.code === 1 && Array.isArray(detailRes.result)) {
            this.traceNodeDetail = cloneDeep(detailRes.result);
            // 获取当前阶段列表 [第一阶段，第二阶段]
            this.getStageList(this.traceNodeDetail.length);
            // 获取步骤条步骤
            this.step = this.getStageStep(
              this.traceNodeDetail[this.stageRadio - 1]
            );
          }

          if (temperRes.code === 1 && Array.isArray(temperRes.result)) {
            this.temperData = cloneDeep(temperRes.result);
            this.handleTemperatureChartData(temperRes.result);
          }

          this.initMap();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async initMap() {
      try {
        // 初始化地图
        await this.$refs.trackMap.init();
        // 请求轨迹数据
        let res = await fetchWholeTraceTrack({
          codeId: this.goodsDetail.codeId
        });

        if (res.code === 1 && Array.isArray(res.result)) {
          let data = res.result;
          // 清空地图点、线
          this.$refs.trackMap.removeTrackFormMap();
          data.forEach((item, index) => {
            // 判断当前轨迹是否有温度,确定颜色
            let color = item.hasTemp
              ? this.trackColorList[0]
              : this.trackColorList[1];
            // 画线
            this.$refs.trackMap.drawLine(item.trackList, color);

            // 画点
            // 开始点
            if (item.nodeList[0]) {
              let startMarkerOpts = this.$refs.trackMap.addStartMarkerToMap(
                item.nodeList[0]
              );
              this.$refs.trackMap.addPointToMap(startMarkerOpts);
            }
            // 如果是最后一个轨迹数据，则画结束点
            if (item.nodeList[1] && index === data.length - 1) {
              let endMarkerOpts = this.$refs.trackMap.addStartMarkerToMap(
                item.nodeList[1]
              );
              this.$refs.trackMap.addPointToMap(endMarkerOpts);
            }
          });
          // 设置中心点
          this.$refs.trackMap.setTrackInView();
        }
      } catch (error) {
        console.log(error);
      }
    },
    reszieChart() {
      if (this.temperChart) {
        this.temperChart.resize();
      }
    },
    // 获取步骤列表
    getStageList(len) {
      let result = [];
      for (let i = 1; i <= len; i++) {
        result.push(i);
      }
      this.stageList = cloneDeep(result);
    },
    // 获取当前步骤
    getStageStep(data) {
      let result = 0;
      // 入库
      if (JSON.stringify(data.warehouse) !== "{}") {
        result += 1;
      }
      // 出库
      if (JSON.stringify(data.exWarehouse) !== "{}") {
        result += 1;
      }
      // 装车
      if (JSON.stringify(data.loadGoods) !== "{}") {
        result += 1;
      }
      // 开始运输
      if (JSON.stringify(data.startTransport) !== "{}") {
        result += 1;
      }
      // 结束运输
      if (JSON.stringify(data.endTransport) !== "{}") {
        result += 1;
      }
      return result;
    },
    // 获取步骤条时间
    getStageStepTime(time) {
      let result = "";
      if (time) {
        result = time.split(" ").join("<br />");
      }
      return result;
    },
    // 阶段选择点击
    handleTraceNodeStageRadioClick(stage) {
      this.stageRadio = stage;
      this.step = this.getStageStep(this.traceNodeDetail[this.stageRadio - 1]);
    },
    // 初始化温度图表
    initTemperatureChart(yData) {
      let dom = this.$refs.temperatureChart;
      let chartWidth = dom.offsetWidth;
      let option = this.getTemperatureChartOption(
        yData,
        this.sceneBTime,
        this.sceneETime,
        this.tempMinOrMax
      );

      this.temperChartWidth = chartWidth - 160;
      this.temperChart = echarts.init(dom);
      this.temperChart.resize();
      this.temperChart.setOption(option);
    },
    // 处理温度图表的数据
    handleTemperatureChartData(resData) {
      let tempMinOrMax = [];
      this.scenes = [];

      // 把节点数据拼凑起来
      let tempData = resData.reduce((total, item) => {
        let sceneLose = 1; // 1-未断链 2-局部断链 3-全部断链
        let tempMin, tempMax;

        // 判断每个场景中的节点是部分断链还是全部断链
        // 根据温度值是否为"-"的个数多少，判断是部分断链还是全部断链
        // 筛选出每个场景中的最高温度和最低温度
        if (Array.isArray(item.sceneTempHumList)) {
          let l = item.sceneTempHumList.length;
          let j = 0;
          let flag = true;

          // 判断 "-" 的个数，以及最高温最低温
          item.sceneTempHumList.forEach(sItem => {
            if (sItem.temp === "-") {
              j += 1;
            } else {
              // 确定每个场景的最高温度和最低温度
              // 首次遇到 temp 不为 "-" 的值，即为最高最低温默认值
              if (flag) {
                tempMin = sItem;
                tempMax = sItem;
                flag = false;
              } else {
                if (tempMin.temp * 1 - sItem.temp * 1 > 0) {
                  tempMin = sItem;
                }
                if (tempMax.temp * 1 - sItem.temp * 1 < 0) {
                  tempMax = sItem;
                }
              }
            }
          });

          // 温度最值
          if (tempMin && tempMax) {
            tempMinOrMax.push(tempMin, tempMax);
          }

          // 判断断链情况
          if (j === 0) {
            // 当前没有为"-"的温度数据且当前场景温度数据为空，则为全部断链
            // 否则为没有断链
            if (l === 0) {
              sceneLose = 3;
            } else {
              sceneLose = 1;
            }
          } else if (j > 0 && j < l) {
            // 如果有温度为"-"的数据，且个数小于所有温度数据，则为部分断链
            sceneLose = 2;
          } else if (j === l) {
            // 如果所有温度数据都为"-"则为全部断链
            sceneLose = 3;
          }

          total.push(...item.sceneTempHumList);
        }

        // 分段数据
        this.scenes.push({
          sceneType: item.sceneType, // 0-场景空隙 1-仓库 2-车辆
          sceneName: item.sceneName, // 场景名称 仓库/车辆名称
          beginTime: moment(item.beginTime).valueOf(),
          endTime: moment(item.endTime).valueOf(),
          sceneLose
        });

        return total;
      }, []);

      // 此处的数据是每个场景中的最高温度和最低温度，处理成echart能够识别的markPoint的集合
      this.tempMinOrMax = tempMinOrMax.map(item => ({
        value: item.temp + "℃",
        coord: [item.gpsTime, item.temp]
      }));

      let yData = [];

      tempData.forEach(item => {
        yData.push([item.gpsTime, item.temp]);
      });

      // 获取开始时间和结束时间，确定x轴的开始时间和结束时间
      if (Array.isArray(this.scenes) && this.scenes.length) {
        // 计算出第一个场景的开始时间
        this.sceneBTime = this.scenes[0].beginTime;
        // 计算出最后一个场景的结束时间
        this.sceneETime = this.scenes[this.scenes.length - 1].endTime;
      }

      this.initTemperatureChart(yData);
    },
    /**
     * 获取温度图表的配置信息
     * @param { } yData y轴数据
     * @param { } min x轴开始数据
     * @param { } max x轴结束数据
     * @param { } markPointData 标点
     */
    getTemperatureChartOption(yData, min, max, markPointData) {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            textStyle: {
              color: "#fff"
            }
          },
          formatter: function(params) {
            let temp = params[0].data[1];
            let time = params[0].data[0];
            if (temp !== "-") {
              return `时间：${time}<br/>温度：${temp}℃`;
            }
          }
        },
        grid: {
          borderWidth: 0,
          top: "50px",
          left: "80px",
          right: "80px",
          bottom: "160px",
          textStyle: {
            color: "#fff"
          }
        },
        calculable: true,
        xAxis: {
          type: "time",
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: "#e6ebf2"
            }
          },
          // minInterval: 60 * 10 * 1000, // 10分钟
          // maxInterval: 60 * 10 * 1000, // 一小时
          axisLabel: {
            show: true,
            textStyle: {
              color: "#898c91"
            },
            formatter: function(value) {
              return moment(value).format("YYYY-MM-DD HH:mm:ss");
            }
          },
          min,
          max
        },
        yAxis: {
          // type: "value",
          // splitLine: {
          //   show: false
          // },
          name: "温度(℃)",
          nameTextStyle: {
            color: "#898c91"
          },
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: "#edf0f5"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#e6ebf2"
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ["#fafbfc", "#fff"]
            }
          },
          axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: "#898c91"
            }
          },
          axisTick: {
            // X轴线 刻度线
            show: false
          }
        },
        series: [
          {
            name: "温度",
            type: "line",
            smooth: false,
            symbolSize: "3",
            symbol: "circle",
            itemStyle: {
              color: "#167be3"
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            markPoint: {
              symbol: "pin", //标记(气泡)的图形
              symbolSize: 50, //标记(气泡)的大小
              data: markPointData
            },
            data: yData
          }
        ]
      };
      return option;
    },
    // 生成场景样式
    getSceneStyle(data) {
      if (this.sceneETime === 0 || this.sceneETime === 0) {
        return 0;
      }

      let total = this.sceneETime - this.sceneBTime;

      let style = {
        width:
          ((data.endTime - data.beginTime) / total) * this.temperChartWidth +
          "px",
        left:
          ((data.beginTime - this.sceneBTime) / total) * this.temperChartWidth +
          "px"
      };

      return style;
    },
    handleGoBack() {
      this.$router.push({
        path: "/goodsTraceWholeProcess",
        query: {
          tagCode: this.tagCode
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.goods-trace-detail {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #edf1f6;
}
.goods-trace-detail-container {
  position: relative;
  width: 100%;
  height: calc(100% - 39px);
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(62, 67, 244, 0.1);
}
.goods-trace-detail-content {
  width: 100%;
  height: calc(100% - 56px);
  overflow-y: auto;
  .main {
    width: 100%;
    .item {
      width: 100%;
      .item-title {
        box-sizing: border-box;
        width: 100%;
        height: 42px;
        line-height: 42px;
        padding: 0 20px;
        background: #fafbfc;
        border: 1px solid #edf0f5;
        display: flex;
        justify-content: space-between;
        &--content {
          margin: 0;
          font-size: 14px;
          line-height: 42px;
          font-weight: bold;
          color: #303133;
        }
      }
    }
  }
  .main {
    // 商品信息
    .goods-info {
      .item-content {
        padding-top: 20px;
        /deep/.el-form {
          .el-form-item__label {
            font-size: 14px;
            color: #849bbd;
          }
          .el-form-item__content {
            font-size: 14px;
            color: #606266;
          }
        }
      }
    }
    // 追溯节点详情
    .trace-node-detail {
      .item-title {
        justify-content: flex-start;
        .stage-radio {
          margin-left: 70px;
          display: flex;
          &--item {
            color: #606266;
            font-size: 14px;
            cursor: pointer;
            & + .stage-radio--item {
              margin-left: 45px;
            }
          }
          .active {
            color: #2f4ef2;
            border-bottom: 2px solid #2f4ef2;
          }
        }
      }
      .item-content {
        padding: 30px 0;
        .item-content-stage {
          &--step {
            width: 80%;
            margin: 0 auto;
            // 覆盖element-ui step 样式
            /deep/.el-steps {
              .el-step {
                .el-step__line {
                  top: 13px;
                }
                .el-step__icon {
                  width: 30px;
                  height: 30px;
                  font-size: 20px;
                }
                .is-success {
                  .el-step__icon {
                    color: #ffffff;
                    background-color: #67c23a;
                  }
                }
                .is-wait {
                  .el-step__icon {
                    background-color: #c0c4cc;
                  }
                }
                .el-step__main {
                  .el-step__title {
                    color: #606266;
                    font-size: 14px;
                  }
                  .el-step__description {
                    color: #909399;
                    font-size: 12px;
                  }
                }
              }
            }
          }
          &--content {
            margin-top: 28px;
            .stage-info {
              display: flex;
              margin-bottom: 18px;
            }
            .stage-info-title {
              width: 70px;
              height: 28px;
              padding-left: 10px;
              color: #ffffff;
              font-size: 14px;
              line-height: 28px;
              border-top-right-radius: 14px;
              border-bottom-right-radius: 14px;
              background-color: #258cff;
            }
            .stage-info-content {
              width: calc(100% - 70px);
              .stage-info-item {
                display: flex;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                color: #606266;
                &--label {
                  width: 200px;
                  color: #849bbd;
                  text-align: right;
                  margin-right: 16px;
                }
              }
            }
          }
        }
      }
    }
    // 追溯全程温度信息
    .trace-whole-temperature {
      .item-content {
        position: relative;
        height: 500px;
        .item-content-wrap {
          width: 100%;
          height: 100%;
        }
        .nodata-wrap {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .item-content-chart {
          height: 100%;
        }
        .all-scene {
          position: absolute;
          bottom: 80px;
          left: 80px;
          height: 30px;
          .scenes {
            .scene-item {
              top: 0;
              height: 30px;
              position: absolute;
              border-width: 0 1px 3px 1px;
              border-style: solid;
              border-color: #c2cdde;
              box-sizing: border-box;
              text-align: center;
              font-size: 14px;

              .title {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
    // 追溯全程轨迹信息
    .trace-whole-track {
      .item-content {
        height: 570px;
      }
    }
  }
}
// 底部返回
.goods-trace-detail-footer {
  width: 100%;
  height: 56px;
  background-color: #fafbfc;
  border: 1px solid #edf0f5;
  box-shadow: 0px -1px 10px 0px rgba(0, 0, 0, 0.07);
  line-height: 56px;
  text-align: center;
  .goback-btn {
    width: 100px;
    height: 36px;
    background: #dae1eb;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #909399;
  }
}
</style>
